export const tsToMillis = (value) => {
  if (!value) return 0;
  if (typeof value === 'number') return value;
  if (value?.seconds) {
    return (value.seconds * 1000) + Math.floor((value.nanoseconds || 0) / 1e6);
  }

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
};

export const isChatUnreadForUser = (chat, uid) => {
  if (!chat || !uid) return false;
  if (chat.isSubscribed === false || chat.unsubscribed === true) return false;

  const unreadAt = tsToMillis(chat?.unread?.[uid]);
  const readAt = tsToMillis(chat?.readBy?.[uid]);
  return unreadAt > readAt;
};

export const countUnreadChatsForUser = (rows = [], uid) => {
  if (!uid) return 0;
  let count = 0;

  (rows || []).forEach((chat) => {
    if (isChatUnreadForUser(chat, uid)) count += 1;
  });

  return count;
};

export const isChatVisibleForUser = (chat, uid) => {
  if (!chat || !uid) return false;

  const deletedAt = tsToMillis(chat?.deletedFor?.[uid]);
  if (!deletedAt) return true;

  const updatedAt = tsToMillis(chat?.updatedAt || chat?.lastMessageAt || chat?.lastMessageCreatedAt);
  return updatedAt > deletedAt;
};